import React from 'react';
import './Footer.css';
import logo from '../../assets/gallery/CLEVRLOGO.png';
import { trackPhoneClick, trackSocialClick } from '../../utils/analytics';

const Footer: React.FC = () => {
  const handlePhoneClick = () => {
    trackPhoneClick('+94774641111');
  };

  const handleSocialClick = (platform: string) => {
    trackSocialClick(platform, 'footer');
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-logo">
          <img src={logo} alt="CLEVR Logo" className="logo-img" />
          <div className="footer-hashtags">
            <p>#CLEVR #CLEVRautomation #SmartHomeColombo #LuxurySmartHome</p>
            <p>#SmartHomeSriLanka #AqaraSriLanka #SmartLighting #SmartDoorLock</p>
            <p>#AppleHomeKit</p>
          </div>
        </div>

        <div className="footer-info">
          <p className="footer-address">385 Galle Rd, Colombo 00300</p>
          <p className="footer-phone">
            <a href="tel:+94774641111" onClick={handlePhoneClick}>077 464 1111</a>
          </p>
        </div>

        <div className="footer-social">
          <a 
            href="https://facebook.com/clevrautomations" 
            className="social-link" 
            aria-label="Facebook"
            onClick={() => handleSocialClick('Facebook')}
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/>
            </svg>
          </a>
          <a 
            href="https://www.instagram.com/clevrautomations" 
            className="social-link" 
            aria-label="Instagram"
            onClick={() => handleSocialClick('Instagram')}
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg viewBox="0 0 24 24" fill="currentColor">
              <rect x="2" y="2" width="20" height="20" rx="5" ry="5" fill="none" stroke="currentColor" strokeWidth="2"/>
              <circle cx="12" cy="12" r="4" fill="none" stroke="currentColor" strokeWidth="2"/>
              <circle cx="18" cy="6" r="1"/>
            </svg>
          </a>
          <a 
            href="https://maps.app.goo.gl/iDPs9VjA3QGSqrSY9" 
            className="social-link" 
            aria-label="Location"
            onClick={() => handleSocialClick('Google Maps')}
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" fill="none" stroke="currentColor" strokeWidth="2"/>
              <circle cx="12" cy="10" r="3" fill="none" stroke="currentColor" strokeWidth="2"/>
            </svg>
          </a>
          <a 
            href="tel:+94774641111" 
            className="social-link" 
            aria-label="Phone"
            onClick={handlePhoneClick}
          >
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z" fill="none" stroke="currentColor" strokeWidth="2"/>
            </svg>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
